import { StaffPlanStateTypes, StaffPlanActionTypes } from "./StaffPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StaffPlanStateTypes = {
  fetchAll: resetApiCallState([]),
};

const StaffPlanReducer = (
  state: StaffPlanStateTypes = INITIAL_STATE,
  action: any
): StaffPlanStateTypes => {
  switch (action.type) {
    case StaffPlanActionTypes.FETCH_ALL_STAFF_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StaffPlanActionTypes.FETCH_ALL_STAFF_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StaffPlanActionTypes.FETCH_ALL_STAFF_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StaffPlanActionTypes.FETCH_ALL_STAFF_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StaffPlanReducer;
